import type { SemanticVersion } from '@/types/SemanticVersion';

export default function (value: string | undefined | null): SemanticVersion | null {
  if (!value) return null;

  const match = /^(\d+)\.(\d+)\.(\d+)/.exec(value.trim());
  if (!match) return null;

  return { major: Number(match[1]), minor: Number(match[2]), patch: Number(match[3]) };
}
